function Programs() {
  const programs = [
    {
      className: 'dallas-program',
      icon: 'fa-backpack',
      title: 'Dallas Back-to-School Initiative',
      location: 'Dallas-Fort Worth, Texas',
      description: 'No child should start the school year without the basics. In Dallas Title I schools, students show up on day one without backpacks, without notebooks, without pencils. Ready to learn but missing the tools. We change that.',
      details: [
        { label: 'The Gap', value: 'Students in Dallas ISD unable to afford basic school supplies' },
        { label: 'Year 1 Impact', value: '30-40 students start school fully equipped' },
        { label: 'What We Provide', value: 'Backpacks, notebooks, calculators, pens, pencils, folders, complete supply kits' },
        { label: 'When', value: 'August distribution + mid-year refills when supplies run out' },
      ],
      cta: 'Equip Dallas Students',
    },
    {
      className: 'nepal-program',
      icon: 'fa-microscope',
      title: 'Nepal Rural STEM Initiative',
      location: 'Ilam District, Eastern Nepal',
      description: 'Bringing the first science labs to schools that have never had electricity. Building STEM programs in classrooms with crumbling walls. Proving that brilliance exists everywhere—it just needs the right tools.',
      details: [
        { label: 'The Reality', value: 'Zero science equipment in rural schools. Students read about experiments they can never perform.' },
        { label: 'Year 1 Impact', value: '40-50 students at Shree Sarada get their first hands-on STEM education ever' },
        { label: 'What We Bring', value: 'Lab kits, STEM equipment, teacher training, STEM clubs, village science fairs' },
        { label: 'The Vision', value: 'First-ever science lab in Dande village. A model for 500+ students by Year 3.' },
      ],
      cta: 'Give Rural Students Their First Lab',
    },
    {
      className: 'exchange-program',
      icon: 'fa-globe-americas',
      title: 'Cross-Cultural Exchange',
      location: 'Dallas \u2194 Nepal Connection',
      description: 'Connecting Dallas and Nepal students through pen pals, virtual exchanges, and mentorship from Dallas STEM professionals.',
      details: [
        { label: 'Activities', value: 'Pen pal programs, virtual classroom exchanges' },
        { label: 'Mentorship', value: 'Dallas tech professionals mentor Nepal students' },
        { label: 'Cultural Learning', value: "Students learn about each other's communities" },
        { label: 'Impact', value: 'Breaking down barriers, building global connections' },
      ],
      cta: 'Become a Mentor',
    },
  ];

  return (
    <section className="programs" id="programs">
      <div className="container">
        <div className="section-header centered">
          <h2 className="section-title">Our Programs</h2>
          <p className="section-subtitle">
            Three interconnected programs serving students across two continents
          </p>
        </div>
        <div className="programs-grid">
          {programs.map((prog, i) => (
            <div className={`program-card ${prog.className}`} key={i}>
              <div className="program-icon">
                <i className={`fas ${prog.icon}`}></i>
              </div>
              <h3 className="program-title">{prog.title}</h3>
              <p className="program-location">
                <i className="fas fa-map-marker-alt"></i> {prog.location}
              </p>
              <p className="program-description">{prog.description}</p>
              <div className="program-details">
                {prog.details.map((d, j) => (
                  <div className="detail-item" key={j}>
                    <strong>{d.label}:</strong> {d.value}
                  </div>
                ))}
              </div>
              <div className="program-cta">
                <a href="#get-involved" className="btn btn-outline">{prog.cta}</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Programs;
